import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    Chart,
    PieSeries,
    Legend,
    Title,
    Tooltip
} from '@devexpress/dx-react-chart-material-ui';
import { Animation, EventTracker } from '@devexpress/dx-react-chart';

//Components

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    paperMain: {
        padding: '10px',
        textAlign: 'center',
        minHeight: "450px",
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    doughnutChart: {
        maxHeight: '270px'
    }
});

class DoughnutChart extends Component {

    render() {
        const { classes, chartData } = this.props;

        return (
            <Chart
                className={classes.doughnutChart}
                data={chartData}
            >
                <PieSeries
                    valueField="val"
                    argumentField="type"
                    innerRadius={0.6}
                />
                <Legend />
                <Title
                    text="Tipologia Licenze"
                />
                <Animation />
                <EventTracker />
                <Tooltip />
            </Chart>
        );

    }
}

DoughnutChart.propTypes = {
    chartData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default withStyles(styles)(DoughnutChart);